import { setGetDashboardWithdrawalsAction } from '../action';
import { getDashboardWithdrawals } from '../api/getDashboardWithdrawals';

export const setGetDashboardWithdrawals = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getDashboardWithdrawals(params);
            dispatch(setGetDashboardWithdrawalsAction(data.data))
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}